export default __webpack_public_path__ + "static/media/eye.f16bd091.svg";